/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum BasketError {
    CAMPAIGN_UNAVAILABLE = 'CAMPAIGN_UNAVAILABLE',
    BASKET_EXPIRED = 'BASKET_EXPIRED',
    MISSING_PACK_CODE = 'MISSING_PACK_CODE',
}
